// In SearchBar.tsx
import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";

interface SearchBarProps {
  searchTerm: string;
  placeholder: string;
  onSearchChange: (value: string) => void;
  onFilterToggle: () => void;
  isFilterOpen: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchTerm, placeholder, onSearchChange, onFilterToggle, isFilterOpen }) => {
  return (
    <TextField
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder={placeholder}
      variant="outlined"
      fullWidth
      className="salon-search-field"
      InputProps={{
        classes: {
          root: "salon-search-input-root",
          input: "salon-search-input",
          focused: "salon-search-focused",
        },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onFilterToggle();
              }}
              edge="end"
              className={`salon-filter-button ${isFilterOpen ? "active" : ""}`}
            >
              <TuneIcon className={`salon-filter-icon ${isFilterOpen ? "active" : ""}`} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
